<div class="table-container">
  <table>
    <thead>
      <tr class="mat-header-row caption-row" *ngIf="showCaptionRow">
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.PRODUCT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DISCOUNT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_FROM" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_TO" | translate }}
        </th>
        <th class="mat-header-cell"></th>
      </tr>
      <tr class="mat-header-row title-row sub-header">
        <th class="mat-header-cell">
          {{ discount.companyName }}
        </th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
      </tr>
    </thead>

    <tbody>
      <tr
        *ngFor="let discount of discount.vipDiscountList; let index = index"
        class="mat-row"
      >
        <td class="mat-cell">
          {{ discount.packagingUnitLabel }}
        </td>
        <td class="mat-cell">
          <span>
            {{ discount.discountValue | number }}
            {{ "VIP_DISCOUNTS." + discount.discountMode | translate }}
          </span>
        </td>
        <td class="mat-cell">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="showOriginalPrice(index)"
          >
            {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
          </button>
        </td>
        <td class="mat-cell">
          <span>
            {{ discount.startDate | date: "YYYY.MM.dd." }}
          </span>
        </td>
        <td class="mat-cell">
          <span>
            {{
              (discount.endDate | date: "YYYY.MM.dd.") ===
              cancellationMockDateHu
                ? ("VIP_DISCOUNTS.GIVEN.UNTIL_CANCELLATION" | translate)
                : (discount.endDate | date: "YYYY.MM.dd.")
            }}
          </span>
        </td>
        <td class="mat-cell actions-cell">
          <div class="actions-cell">
            <button
              class="me-4"
              mat-raised-button
              color="primary"
              (click)="addToOrderList([discount.packagingUnitId ?? ''])"
            >
              {{ "VIP_DISCOUNTS.ADD_TO_CART" | translate }}
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
